import { render, staticRenderFns } from "./AssetOverview.vue?vue&type=template&id=66dfe446&"
import script from "./AssetOverview.vue?vue&type=script&lang=ts&"
export * from "./AssetOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports